import { useAuth } from "../../../../context";
import { useMutation } from "react-query";
import { General } from "../../../../api/supplier-questionnaire/tabs";

export function useCreateGeneralData(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(General.createGeneralData, { questionnaireId, data }), config);
}

export function useUpdateGeneralData(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, id, data}) =>
    callApi(General.updateGeneralData, { questionnaireId, id, data }), config);
}